import React from 'react';
import './StyledInput.css';

const StyledTimeInput = ({ value, onChange, label, placeholder }) => {
  return (
    <div className="styled-input-wrapper flight">
      <label className="styled-input-label">{label}</label>
      <div className="styled-input-container">
        <div className="styled-input-icon">🕐</div>
        <input
          type="time"
          className="styled-input"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};

export default StyledTimeInput;

